import React, { useEffect } from "react";
import { GridColDef } from "@mui/x-data-grid-premium";
import { Chip, Stack, TableContainer } from "@mui/material";
import DataGridTable from "../../base/DataGridTable";
import { useDispatch, useSelector } from "../../../store";
import TableActions from "../../base/TableActions";
import { fetchAlerts } from "../../../slices/alert";
import { TileTypes } from "../../../types/tileType";

interface Props {
  handleView?: (id: number) => void;
  handleEdit?: (id: number) => void;
  handleDisable?: (id: number) => void;
}

const ActiveAlertsTable: React.FC<Props> = (props) => {
  const { handleView, handleEdit, handleDisable } = props;

  const dispatch = useDispatch();
  const { activeAlerts, status } = useSelector((store) => store.alert);

  useEffect(() => {
    dispatch(fetchAlerts());
  }, [dispatch]);

  const rows =
    activeAlerts &&
    activeAlerts?.map((alert) => {
      let rowObject = {
        id: alert.tileId,
        name: `${alert.tileName}`,
        tileType: `${alert.tileType}`,
        alertType: alert.alertType.value,
        alertDelivery: alert.alertDeliveries?.map((r) => (
          <Chip
            key={r.id}
            label={r.value}
            size="small"
            sx={{ m: 0.25 }}
            color="info"
          />
        )),
        datasets: `⚠️ ${alert.alertData}`,
        actions: (
          <TableActions
            id={alert.tileId!}
            handleView={
              handleView ? () => handleView!(alert.tileId!) : undefined
            }
            handleEdit={
              handleEdit ? () => handleEdit!(alert.tileId!) : undefined
            }
            handleDelete={
              handleDisable ? () => handleDisable!(alert.tileId!) : undefined
            }
          />
        ),
      };

      return rowObject;
    });

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Tile Name",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "tileType",
      headerName: "Tile Type",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "alertType",
      headerName: "Alert Type",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "alertDelivery",
      headerName: "Notification Type",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
      renderCell: (params) => (
        <Stack
          direction="row"
          flexWrap="wrap"
          height="100%"
          justifyContent="center"
          alignContent="center"
        >
          {params.value}
        </Stack>
      ),
    },
    {
      field: "datasets",
      headerName: "Alert Data",
      headerAlign: "center",
      align: "center",
      flex: 2,
      headerClassName: "header",
    },
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      disableExport: true,
      renderCell: (params) => <>{params.value}</>,
      headerClassName: "header",
    },
  ];

  return (
    <TableContainer>
      <DataGridTable
        columns={columns}
        rows={(status !== "loading" && rows) || []}
        loading={status === "loading"}
      />
    </TableContainer>
  );
};

export default ActiveAlertsTable;
